import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/profiles')({
  loader: () => {
    throw redirect({ to: '/profile/list', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
